import api from './client'
import { LoginCredentials } from '../types'

/**
 * Response from the Azure SSO bridge endpoint
 */
export interface AzureBridgeResponse {
  created: boolean
  user: {
    email: string
    display_name: string
    emp_id: string | null
  }
  // Optional CSRF token returned by bridge when session-based auth is established
  csrf_token?: string | null
}

/**
 * Legacy login with email/password (for backend admin only)
 * @deprecated Use Azure SSO for frontend authentication
 */
export const login = async (credentials: LoginCredentials) => {
  const response = await api.post('/auth/login/', credentials)
  return {
    user: response.data.user,
    token: response.data.access, // Use 'access' token from Django JWT response
    refresh: response.data.refresh
  }
}

/**
 * Exchange Azure AD id_token with backend to establish a session
 * This is the primary authentication method for the frontend
 */
export const azureBridge = async (idToken: string): Promise<AzureBridgeResponse> => {
  const response = await api.post<AzureBridgeResponse>('/auth/azure/bridge/', {
    id_token: idToken,
  })
  return response.data
}

/**
 * Logout - clears the session on the backend
 */
export const logout = async () => {
  const response = await api.post('/auth/logout/')
  return response.data
}

/**
 * Get current user information from the backend
 */
export const getCurrentUser = async () => {
  const response = await api.get('/auth/me/')
  return response.data
}

/**
 * Refresh the JWT token (for legacy auth only)
 * @deprecated SSO uses session-based auth
 */
export const refreshToken = async () => {
  const refresh = localStorage.getItem('refresh_token')
  const response = await api.post('/auth/refresh/', { refresh })
  return {
    token: response.data.access
  }
}
